import { useEffect, useLayoutEffect, useState, useRef } from "react";
import { connect, useStore } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import useMedia from "use-media";
import commonUtil from "../../common/commonUtil";
import { apiKeyCheck, versionGetApi } from "../../const";
import common from '../../resources/js/common/common';
import { Button } from "../atoms/button";
import { Label } from '../atoms/label';
import './../../resources/css/reservationConfirm/reservationConfirm.css';
import { GolfFooterContainer } from "./golfFooterContainer";
import '../../resources/css/soloReserve/golfSoloBookingConfirmDetail.css'
import messageConst from "../../const/messageConst";

const GolfSoloBookingConfirmDetailContainer = (props) => {
    const {
        golfSoloReserveInfo,
        onClickOpenCancelPopupWindow,
    } = props;

    //レスポンシブ対応
    const useMediaFlag = useMedia({ maxWidth: '480px' });

    const history = useHistory();
    const store = useStore();


    useLayoutEffect(() => {
        // リフレッシュ対応
        let state = store.getState().login;
        let apiKey = null;
        if (Object.keys(state).length !== 0) {
            apiKey = state.apiKey;
        }
        if (apiKey === null) {
            store.dispatch({ type: "CLEAR_STATE" });
            history.push("/reserve/login");
        }
        if (apiKey) {
            common.doPost(apiKeyCheck, { apikey: apiKey }, afterApiKeyCheck);
        }
    })
    const afterApiKeyCheck = (res) => {
        if (!res.data) {
            console.log("バックからの戻り値false");
            store.dispatch({ type: "CLEAR_STATE" });
            history.push("/reserve/login");
        }
    }

    useEffect(() => {
        common.doPost(versionGetApi, {}, afterVerCheck);
        window.scroll({ top: 0, behavior: 'smooth' })
    }, [useMediaFlag]);

    const afterVerCheck = (res) => {
        let flg = common.versionCheck(res.data.version);
        if (flg) {
            history.push("/reserve/login");
            return;
        }
    }

    const timeForm = (res) => {
        res = res.replace(":","");
        let time = "";
        if (res.substr(0, 1) === '0') {
            time = res.substr(1, 1);
        } else {
            time = res.substr(0, 2);
        }
        time = time + "時";

        if (res.substr(2, 1) === '0') {
            time = time + res.substr(3, 1);
        } else {
            time = time + res.substr(2, 2);
        }
        time = time + "分";
        return time;
    }

    const playerConvert = (name, kanaName) => {
        if (name === "未記入") {
            return "未定";
        } else if (name && kanaName) {
            return name + "(" + kanaName + ") 様";
        } else if (name && !kanaName) {
            return name + " 様";
        } else {
            return kanaName + " 様";
        }
    }
    return (
        <div className="soloBookingConf_InputInnerWrapper">
            <div className="soloBookingConf_breadCrumb">
                <Link to={"/reserve/top"} className="soloBookingConf_pan" >HOME</Link>
                <Label label=">" className="soloBookingConf_breadCrumbArrow" />
                <Link to={"/reserve/golf/soloSearch"} className="soloBookingConf_pan" >ゴルフ一人予約</Link>
                <Label label=">" className="soloBookingConf_breadCrumbArrow" />
                <Label label="予約詳細確認" className="soloBookingConf_pan" />
            </div>
            <div className="soloBookingConf_confirmWrapper">
                <div className="soloBookingConf_reserveContentWrapper">
                    <Label label="ご予約内容" className="soloBookingConf_reserveConirmTitle" />
                    <div className="soloBookingConf_fullWidth">
                        <div className="soloBookingConf_ReserveContents">
                            <Label
                                label="プレー日"
                                className="soloBookingConf_confirmTitleLabel"
                            />
                            <Label
                                label={golfSoloReserveInfo.playDate ? commonUtil.getStringFromDateJpnGolf(golfSoloReserveInfo.playDate.substr(0, 10)) : ""}
                                className="soloBookingConf_contentLabel"
                            />
                        </div>
                        <div className="soloBookingConf_ReserveContents">
                            <Label
                                label="ゴルフ場"
                                className="soloBookingConf_confirmTitleLabel"
                            />
                            <Label
                                label={golfSoloReserveInfo.golfCourseName}
                                className="soloBookingConf_contentLabel"
                            />
                        </div>
                        <div className="soloBookingConf_ReserveContents">
                            <Label
                                label="お問合せ番号"
                                className="soloBookingConf_confirmTitleLabel"
                            />
                            <Label
                                label={golfSoloReserveInfo.soloEntryReservationNo}
                                className="soloBookingConf_contentLabel"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="soloBookingConf_confirmWrapper">
                <div className="soloBookingConf_reserveContentWrapper">
                    <Label label="プレー情報" className="soloBookingConf_reserveConirmTitle" />
                    <div className="soloBookingConf_fullWidth">
                        <div className="soloBookingConf_ReserveContents">
                            <Label
                                label="コース名"
                                className="soloBookingConf_confirmTitleLabel"
                            />
                            <Label
                                label={golfSoloReserveInfo.courseName}
                                className="soloBookingConf_contentLabel"
                            />
                        </div>
                        <div className="soloBookingConf_ReserveContents">
                            <Label
                                label="スタート時間"
                                className="soloBookingConf_confirmTitleLabel"
                            />
                            <Label
                                label={golfSoloReserveInfo.teetime ? timeForm(golfSoloReserveInfo.teetime) : ""}
                                className="soloBookingConf_contentLabel"
                            />
                        </div>
                        <div className="soloBookingConf_ReserveContentsPlayer">
                            <Label
                                label="名前"
                                className="soloBookingConf_confirmTitleLabel"
                            />
                            <div className="soloBookingConf_fullWidth">
                                <Label
                                    label={playerConvert(golfSoloReserveInfo.playerName, golfSoloReserveInfo.playerNameKana)}
                                    className="soloBookingConf_contentLabel"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="soloBookingConf_btnWrapper">
                <div className="soloBookingConf_boxWrap">
                    <Button buttonText="予約をキャンセル" className="soloBookingConf_cancelBtn" onClick={() => onClickOpenCancelPopupWindow()} buttonClassName="soloBookingConf_marginAuto" />
                    <Label label={messageConst.GOLF_SOLO_CANCEL_ANNOTATION} className="soloBookingConf_cancelAnnotation" />
                </div>
            </div>
            <div className="soloBookingConf_footer">
                <GolfFooterContainer />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        golfSoloReserveInfo: state.golfSoloReserveInfo,
    };
};


export default connect(mapStateToProps, null)(GolfSoloBookingConfirmDetailContainer);
